export const projects = [
  {
    title: "Wanderlust - Travel Listing Web App",
    description:
      "A dynamic web application for exploring and posting travel listings. Features user authentication, reviews, and image uploads.",
    techStack: ["Node.js", "Express", "MongoDB", "EJS", "Cloudinary"],
    liveLink: "https://wanderlust-travel-marketplace.onrender.com/listings",
    codeLink: "https://github.com/ParasJagdale/wanderlust-travel-marketplace",
    image: "/images/Wanderlust.png",
    featured: true,
  },
  {
    title: "MERN-Based Investment Platform (Inspired by Zerodha)",
    description:
      "A full-featured stock trading interface using React, Node.js, and MongoDB.",
    techStack: ["React", "Node.js", "MongoDB"],
    liveLink: "https://zerodha-clone-frontend.vercel.app/",
    codeLink: "https://github.com/ParasBot/Zerodha-Clone",
    image: "/images/mern.png",
    featured: true,
  },
  {
    title: "Django-Based Image Sharing App (Shario)",
    description:
      "A platform to upload and share images securely, built with Django and Bootstrap.",
    techStack: ["Django", "Bootstrap", "SQLite"],
    liveLink: "https://github.com/ParasBot/Django-intership-project",
    codeLink: "https://github.com/ParasBot/Django-intership-project",
    image: "/images/python.png",
  },
  {
    title: "Weather Forecast React App",
    description:
      "A responsive weather app fetching real-time weather data via OpenWeather API.",
    techStack: ["React", "API", "CSS"],
    liveLink: "https://weather-app-react-three-nu.vercel.app/",
    codeLink: "https://github.com/ParasBot/Weather-App-React",
    image: "/images/weather.png",
  },
  {
    title: "SplashCursor - Animated React Component",
    description:
      "An interactive cursor effect component with colorful splash animations, multiple themes, and performance-optimized rendering for modern React applications.",
    techStack: ["React", "Tailwind CSS", "JavaScript", "CSS Animations"],
    liveLink:
      "https://claude.ai/public/artifacts/679237c5-5b18-4ff0-a2fb-26e89fa77baf",
    codeLink: "#",
    image: "/images/cursor.png",
  },
  {
    title: "Lucky Numbers - React Lottery Simulator",
    description:
      "An engaging lottery simulation app featuring random number generation, animated ball draws, ticket purchasing system, and comprehensive statistics tracking.",
    techStack: ["React", "Tailwind CSS", "JavaScript", "React Hooks"],
    liveLink: "https://lottery-game-chi.vercel.app/",
    codeLink: "https://github.com/ParasBot/Lottery-Game",
    image: "/images/lottery.png",
  },
  {
    title: "AI Interviewer - Mock Interview Platform",
    description:
      "A smart interview simulation tool for students that generates personalized interview questions from uploaded resumes and job descriptions, with instant AI-based feedback and scoring.",
    techStack: ["HTML", "CSS", "JavaScript", "OpenRouter API", "PDF.js"],
    liveLink: "https://mock-interview-app-three.vercel.app/", // Replace with your deployed link
    codeLink: "https://github.com/ParasJagdale/mock-interview-app", // Replace with your actual repo link
    image: "/images/AI_Interviewer.png", // Replace with actual image path
    featured: true,
  },
];
